module.exports = __webpack_public_path__ + "img/brand_logo_pc.039dc499.png";